import { TuneControlsDisclaimerType } from '@/engine/app/interfaces';
import { MorphingInfo } from './MorphingInfo';
import { SelectDeviceInfo } from './SelectDeviceInfo';
import type React from 'react';

interface Props {
  disclaimer?: TuneControlsDisclaimerType;
}

export const TuneInfoComponentsFactory: React.FC<Props> = (props) => {
  switch (props.disclaimer) {
    case TuneControlsDisclaimerType.Device:
      return <SelectDeviceInfo />;
    case TuneControlsDisclaimerType.Morphing:
      return <MorphingInfo />;
    default:
      return null;
  }
};
